import { Component, ViewChild, HostListener, ElementRef, OnInit } from '@angular/core';
import { Login } from '../pages/login/login';
import { AuthService } from '../services/auth-service';
import { Api } from '../services/api';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  standalone: false,
  templateUrl: './header.html',
  styleUrl: './header.scss'
})
export class Header implements OnInit{
@HostListener('document:click', ['$event'])
clickOutside(event: Event) {

  const target = event.target as HTMLElement;

  const clickedInsideProfile =
    target.closest('.profile-container');

  const clickedInsideAside =
    target.closest('.custom-sidebar');

  const clickedallSceen =
    target.closest('.btn-secondarymylerning');

  if (!clickedInsideProfile && !clickedInsideAside && !clickedallSceen) {

    this.isDropdownOpen = false;
    this.isDropdownOpenSubmenu = false;
    this.isDropdownOpenSubmenuAside = false;
    this.isLearningSidebarOpen = false

  }
}
isLoggedIn: boolean = false;
isSidebarOpen = false;
isLandscapeMobile = false;
fullname:any = ''
profilePhoto: string = '';
isDropdownOpen = false;
isDropdownOpenSubmenu= false;
isDropdownOpenSubmenuAside= false;
traininCourses: any = {};
user:any;
@ViewChild('authModal') authModal!: Login;
constructor(public authService: AuthService,private apiService: Api,private router: Router) {
    this.authService.isLoggedIn$.subscribe(status => {
      this.isLoggedIn = status;
    });
    const userString = this.authService.getUser();

  if (userString) {
    this.user = typeof userString === 'string'
      ? JSON.parse(userString)
      : userString;

    
  }
   


  }
  ngOnInit(): void {
     console.log("this.user",this.user)
     this.getCourses()
     
     if(this.user?.data?.userType === 'USER'){
           this.fullname = this.user?.data?.fullName 
           this.profilePhoto = this.user?.data?.profilePicture || '';
           
     }
     else{
        this.fullname = this.user?.fullName || '';
        this.profilePhoto = this.user?.image || '';
        console.log("this.profilePhoto",this.profilePhoto)
     }
     
  }
   getCourses() {
    this.apiService.getCourseList().subscribe((result: any)=> {
      this.traininCourses = result?.data[0] || {};
      console.log("this.traininCourses",this.traininCourses)
    })
  }
navgate(courseName: string) {
    this.router.navigate(['/main-course'],{queryParams: {courseName: courseName}})
      .then(success => console.log("Navigation success:", success))
      .catch(err => console.error("Navigation error:", err));
  }
toggleDropdown() {
  this.isDropdownOpen = !this.isDropdownOpen;
}
toggleDropdownsub(event: Event) {
  event.stopPropagation();
  this.isDropdownOpenSubmenu = !this.isDropdownOpenSubmenu;
 
}
toggleDropdownsubaside(event: Event) {
  event.stopPropagation();
  this.isDropdownOpenSubmenuAside = !this.isDropdownOpenSubmenuAside;
 
}
toggleDropdownsubUp(event: Event) {
  event.stopPropagation();
  this.isDropdownOpenSubmenu = !this.isDropdownOpenSubmenu;
  this.isDropdownOpen = false
}
toggleSidebar() {
  this.isSidebarOpen = !this.isSidebarOpen;
}
isLearningSidebarOpen = false;

toggleLearningSidebar() {

  // Only allow on desktop
  if (window.innerWidth >= 992) {
    this.isLearningSidebarOpen =
      !this.isLearningSidebarOpen;
  }

}
openLoginModal() {
    this.authModal.openModal('login');
  }
 openSignupModal() {
    this.authModal.openModal('signup');
  }
 onModalClosed() {
    console.log('Modal was closed');
  }
openRegistrationModal() {
  this.authModal.openModal('register'); 
}
openEnquiryModal() {
  this.authModal.openModal('enquiry'); 
}
  logout() {
    this.authService.logout();
  }
redirect(){
  this.isDropdownOpen = false;
}
}
